/**
 * NSM waitlist — native React/HTML form. POSTs to Brevo simple HTML endpoint.
 * No iframe, no Brevo script. Fully styled to match NSM dark luxury design.
 */
import React from "react";
import { site } from "../../config/site";

export default function WaitlistEmbed() {
  const formAction = site.waitlistFormUrl;
  if (!formAction) return null;

  return (
    <div className="nsm-waitlist-card">
      <div className="nsm-waitlist-card__accent" aria-hidden="true" />
      <span className="nsm-waitlist-card__badge">NSM 2026</span>
      <h3 className="nsm-waitlist-card__title">{site.waitlistTitle}</h3>
      <p className="nsm-waitlist-card__subtext">{site.waitlistSubtext}</p>

      <div className="nsm-waitlist-card__form">
        <form
          className="nsm-waitlist-form"
          method="POST"
          action={formAction}
          target="_self"
          noValidate
        >
          <input type="hidden" name="email_address_check" value="" />
          <input type="hidden" name="locale" value="en" />
          <input type="hidden" name="html_type" value="simple" />

          <div className="nsm-waitlist-form__row">
            <label htmlFor="nsm-waitlist-email" className="nsm-waitlist-form__label">
              Email
            </label>
            <input
              id="nsm-waitlist-email"
              type="email"
              name="EMAIL"
              className="nsm-waitlist-form__input"
              placeholder="Enter your email address to join the waitlist"
              required
              autoComplete="email"
              aria-required="true"
              aria-describedby="nsm-waitlist-hint"
            />
            <p id="nsm-waitlist-hint" className="nsm-waitlist-form__hint">
              We&apos;ll send a confirmation link to your inbox.
            </p>
          </div>

          <div className="nsm-waitlist-form__row nsm-waitlist-form__row--submit">
            <button type="submit" className="nsm-waitlist-form__submit">
              Join Waitlist
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
